/**
 * Winteres price format cleanup
 * Strips trailing ".00" or ",00" from displayed prices when the amount is whole.
 * Examples:
 *   $257.00 → $257
 *   225,00€ → 225€
 *   CA$365.00 → CA$365
 * Preserves prices with non-zero cents (e.g. $225.64 stays as $225.64).
 *
 * Approach: text-node walker on price-related selectors, plus MutationObserver
 * for dynamic content (variant swap, cart updates, quick-view, wishlist grid).
 */
(function () {
  'use strict';

  // Common Shopify + Wonder theme + Winteres custom price selectors.
  var PRICE_SELECTORS = [
    '.money',
    '.price', '.price__current', '.price__regular', '.price__sale',
    '.wt-price', '.wt-price__number', '.wt-price__amount',
    '[data-money]', '[data-price]',
    '.product-price', '.product__price',
    '.line-item-price', '.line-item__price',
    '.cart-price', '.cart__price', '.cart-item__price',
    '.total-price', '.subtotal-price',
    '.wt-cart-item__price', '.wt-product__price',
    '.wishlist-fav__item__price',
    '[class*="price"]',
    '[class*="Price"]'
  ].join(',');

  // Strip ".00" or ",00" that appear at end of a numeric segment in a price string.
  // Regex breakdown:
  //   (\d)      — captured digit (kept in result)
  //   [.,]00    — decimal separator followed by literal "00"
  //   (?=\s|[^\d]|$) — followed by whitespace, non-digit char, or end-of-string
  function stripZeroCents(text) {
    if (!text) return text;
    return text.replace(/(\d)[.,]00(?=\s|[^\d]|$)/g, '$1');
  }

  function processElement(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    var toUpdate = [];
    while ((node = walker.nextNode())) {
      if (node.nodeValue && /[.,]00/.test(node.nodeValue)) {
        toUpdate.push(node);
      }
    }
    for (var i = 0; i < toUpdate.length; i++) {
      var newText = stripZeroCents(toUpdate[i].nodeValue);
      if (newText !== toUpdate[i].nodeValue) {
        toUpdate[i].nodeValue = newText;
      }
    }
  }

  function processAllPrices() {
    var elements = document.querySelectorAll(PRICE_SELECTORS);
    for (var i = 0; i < elements.length; i++) {
      processElement(elements[i]);
    }
  }

  // Debounced re-run on DOM changes (variant swap, quick-view, cart updates).
  var observer;
  var scheduled = false;

  function scheduleReprocess() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      if (observer) observer.disconnect();
      processAllPrices();
      startObserving();
    });
  }

  function startObserving() {
    if (!document.body) return;
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: false
    });
  }

  observer = new MutationObserver(scheduleReprocess);

  function init() {
    processAllPrices();
    startObserving();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
